import { html } from 'lit-element';

import { LightLitElement } from '@elab/components';
import connect from '@elab/core/store/connect';
import { selectors as globalSelectors } from '@elab/core/store/global';

/**
 * Component uses for configure layout of wishlist component
 *
 * @author Zhynzher Oleksandr
 *
 * HTML Structure Example
 *
 * <e2-wishlist-grid-layout
 *      product="Product Data"
 *      add-to-wishlist-enable="Enable wishlist button on product tile"
 *      add-to-cart-enable="Enable add to cart button on product tile"
 *      in-stock-label="In stock label">
 * </e2-wishlist-grid-layout>
 * */

export class WishlistGridLayout extends LightLitElement {
    static get properties() {
        return {
            defaultImagePath: { type: String, attribute: false },
            product: { type: Object, attribute: 'product' },
            hideCountDown: { type: Boolean, attribute: 'hide-count-down' },
            addToWishlistEnable: { type: Boolean, attribute: 'add-to-wishlist-enable' },
            addToCartEnable: { type: Boolean, attribute: 'add-to-cart-enable' },
            priceStyleClass: { type: String, attribute: 'price-style-color' },
            inStockLabel: { type: String, attribute: 'in-stock-label' },
            outOfStockLabel: { type: String, attribute: 'out-of-stock-label' },
            membershipLabel: { type: String, attribute: 'membership-label' },
            isThresholdPromotionEnabled: {
                type: Boolean,
                attribute: 'is-threshold-promotion-enabled',
            },
            thresholdPriceLabel: { type: String, attribute: 'threshold-price-label' },
        };
    }

    constructor() {
        super();
        this.product = {};
        this.hideCountDown = false;
        this.addToWishlistEnable = false;
        this.addToCartEnable = false;
        this.priceStyleClass = '';
        this.isThresholdPromotionEnabled = false;
        this.thresholdPriceLabel = '';
    }

    render() {
        return html`
            <div class="product-tile-wrapper">
                <e2-product-item
                    .product=${this.product}
                    missing-image-path=${this.defaultImagePath}
                    ?add-to-cart-enable=${this.addToCartEnable}
                    ?add-to-wish-enable=${this.addToWishlistEnable}
                    price-style-color=${this.priceStyleClass}
                    in-stock-label=${this.inStockLabel}
                    out-of-stock-label=${this.outOfStockLabel}
                    image-type="GALLERY"
                    membership-label=${this.membershipLabel}
                    is-wishlist-layout
                    ?is-threshold-promotion-enabled=${this.isThresholdPromotionEnabled}
                    threshold-price-label=${this.thresholdPriceLabel}
                ></e2-product-item>
            </div>
        `;
    }
}

const mapStateToProps = state => ({
    defaultImagePath: globalSelectors.getImagePlaceholderPath(state),
});

export default () =>
    customElements.define('e2-wishlist-grid-layout', connect(mapStateToProps)(WishlistGridLayout));
